// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {TopBar} from 'app/components/TopBar';
import styles from './NotFound.styles.js';
import {Footer} from 'app/components/Footer';

class NotFound extends React.Component<Props> {
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.root}>
          <TopBar />
          <div className={classes.cover} />
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

const Component = withStyles(styles, {withTheme: true })(NotFound);
export {Component as NotFound};
export default Component;